import { jsx as _jsx } from "react/jsx-runtime";
import Markdown from "markdown-to-jsx";
import { CodeBlock } from "./CodeBlock.js";
import { MarkdownScript, isMarkdownScript } from "./MarkdownScript.js";
import { Heading } from "./Heading.js";
import { MarkedLink } from "./MarkedLink.js";
const codeBlock = "3";
const options = {
    forceBlock: true,
    renderRule(next, node, _render, state) {
        if (node.type === codeBlock) {
            const code = node.text;
            return _jsx(CodeBlock, { lang: node.lang, code: code }, state.key);
        }
        if (isMarkdownScript(node)) {
            return _jsx(MarkdownScript, { ...node }, state.key);
        }
        try {
            return next();
        }
        catch (e) {
            if (e instanceof Error) {
                e.message = `${e.message}: while rendering node: ${JSON.stringify(node)}`;
            }
            throw e;
        }
    },
    overrides: {
        ul: {
            component: "ul",
            props: { className: "pl-6 list-disc" },
        },
        ol: {
            component: "ol",
            props: { className: "pl-6 list-decimal" },
        },
        code: {
            component: "code",
            props: { className: "bg-gray-200 rounded px-1" },
        },
        a: { component: MarkedLink },
        h1: { component: Heading, props: { depth: 1 } },
        h2: { component: Heading, props: { depth: 2 } },
        h3: { component: Heading, props: { depth: 3 } },
        h4: { component: Heading, props: { depth: 4 } },
    },
};
export function MarkedContent({ raw }) {
    return (_jsx("div", { "data-testid": "marked", children: _jsx(Markdown, { options: options, children: raw }) }));
}
